const reducer = state => ({
  ...state,
  active: false,
  error: true,
});

export default reducer;
